interface QueryParams {
    page?: number;
    size?: number;
    sortBy?: string[];
    sortDirections?: ('asc' | 'desc')[];
    filters?: Record<string, any>;
}

const buildUrl = (baseEndpoint: string, params?: QueryParams): string => {
    const queryParts: string[] = [];

    if (params?.page) queryParts.push(`page=${params.page}`);
    if (params?.size) queryParts.push(`size=${params.size}`);
    if (params?.sortBy && params.sortBy.length > 0) queryParts.push(`sortBy=${params.sortBy.join(',')}`);
    if (params?.sortDirections && params.sortDirections.length > 0) queryParts.push(`sortDirection=${params.sortDirections.join(',')}`);
    if (params?.filters) {
        Object.keys(params.filters).forEach((key) => {
            queryParts.push(`filter:${key}=${encodeURIComponent(params.filters![key])}`);
        });
    }

    const queryString = queryParts.join('&');

    if (queryString)
        return `${baseEndpoint}?${queryString}`;
    return baseEndpoint;
};

export default buildUrl;